import ConfirmAccountPage from './ConfirmAccountPage';
export { ConfirmAccountPage };
export default ConfirmAccountPage;
